const phoneRE = /^(1|)?(\d{3})(\d{3})(\d{4})$/;
export const formatPhone = (phone: string): string => {
  const matched = phone.match(phoneRE);
  return matched ? `(${matched[2]}) ${matched[3]}-${matched[4]}` : phone;
};
